export default __webpack_public_path__ + "static/media/linkedin.6d5d5e70.svg";